<template>
  <div class="home">
    <div
      class="primary d-none d-sm-none d-md-block d-lg-block d-xl-block top-bar"
    >
      <v-row justify="space-around">
        <v-col cols="12" sm="12" md="1" lg="1">
          <span class="white--text"></span>
        </v-col>
        <v-col cols="12" sm="12" md="3" lg="3" class="mt-2 mb-2">
          <!-- <span class="white--text"
            ><span class="white--text"
              ><v-icon color="#FFF" small>mdi-phone</v-icon> 81100 20091</span
            ></span
          > -->
          <v-btn color="white" class="mr-2" outlined @click="priceListOpen"
            >Download Price List</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2"> </v-col>
        <v-col cols="12" sm="12" md="1" lg="2"> </v-col>
        <v-col cols="12" sm="12" md="3" lg="3" class="mt-2 mb-2">
          <v-btn
            color="white"
            class="mr-2"
            outlined
            href="retail-payment-confirm"
            >Payment Confirmation</v-btn
          >

          <v-icon size="45" @click="paymentYoutubeopen" color="white">
            mdi-youtube
          </v-icon>
          <!-- <span class="white--text"
            ><v-icon color="#FFF" small>mdi-email</v-icon>
            kannancrackers2015@gmail.com</span
          > -->
        </v-col>
        <!-- <v-col cols="12" sm="12" md="1" lg="1">
          <span class="white--text"></span>
        </v-col> -->
      </v-row>
    </div>

    <v-app-bar color="white" fixed height="125px" class="mt-md-8 mt-lg-8">
      <v-container>
        <v-row
          justify="space-around"
          id="container"
          ref="container"
          class="mt-5"
        >
          <v-col
            cols="12"
            md="6"
            lg="6"
            large
            class="d-none d-sm-none d-md-block d-lg-block d-xl-block"
          >
            <!-- <v-breadcrumbs :items="menus" divider=" ">
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item :href="item.href">
                  <v-btn small color="secondary" class="mb-2">{{
                    item.text
                  }}</v-btn>
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs> -->
            <div
              class="d-flex flex-row flex-wrap align-center menu-btn-group"
              style="gap: 12px 18px"
            >
              <div v-for="(menu, index) in menus" :key="index">
                <v-btn
                  small
                  color="secondary"
                  class="mb-2"
                  style="
                    min-width: 120px;
                    font-weight: 500;
                    letter-spacing: 0.5px;
                  "
                  :href="menu.href"
                >
                  {{ menu.text }}
                </v-btn>
              </div>
              <div class="text-center ml-3 mt-n2">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="secondary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      small
                    >
                      Blog
                    </v-btn>
                  </template>
                  <v-list>
                    <div v-for="item in getBlogList" :key="item.id">
                      <v-list-item :href="`/blog/${item.id}`">
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </v-col>
          <div class="d-block d-sm-block d-md-none d-lg-none d-xl-none">
            <!-- <v-breadcrumbs :items="menus"></v-breadcrumbs> -->
            <img alt="Vue logo" src="../assets/logo.png" height="60" contain />
            <v-app-bar-nav-icon
              @click.stop="drawer = !drawer"
            ></v-app-bar-nav-icon>
          </div>
          <v-col
            cols="12"
            sm="12"
            md="6"
            lg="3"
            class="d-none d-sm-none d-md-block d-lg-block d-xl-block"
          >
            <img alt="Vue logo" src="../assets/logo.png" height="60" contain />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
            lg="3"
            class="d-flex justify-space-between flex-row text-wrap"
          >
            <v-btn icon v-if="cartQty" class="mb-8" @click="popupCheckout">
              <v-badge
                color="black"
                :content="cartQty"
                overlap
                offset-x="10"
                offset-y="10"
              >
                <v-icon color="black">mdi-cart-outline</v-icon>
              </v-badge>
            </v-btn>
            <v-btn icon v-if="cartQty == ''" class="mb-8">
              <v-badge
                color="black"
                content="0"
                overlap
                offset-x="10"
                offset-y="10"
                bordered
              >
                <v-icon color="black">mdi-cart-outline</v-icon>
              </v-badge>
            </v-btn>
            <v-btn text class="mb-8">
              <div class="d-none d-sm-none d-md-block d-lg-block d-xl-block">
                NET TOTAL :
              </div>
              ₹ {{ productSalesPrice }}
            </v-btn>
            <v-btn outlined color="primary" @click="contactDialog = true"
              ><v-icon color="primary" small class="mr-2">mdi-phone</v-icon
              >Contact</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-dialog v-model="contactDialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Contact Details
        </v-card-title>
        <!-- <v-card-text>
          <p class="mb-1 mt-5">
            <v-icon color="primary" small>mdi-phone</v-icon> Order Confirmation
            : 93843 57572, 80569 03599, 73971 53601, 97504 44600, 75388 97572
          </p>
          <p class="mb-1">
            <v-icon color="primary" small>mdi-phone</v-icon> Payment
            Confirmation: 97905 72926, 97900 39111, 97900 25111, 63854 27540,
            63854 27539
          </p>
          <p class="mb-1 mt-5">
            <v-icon color="primary" small>mdi-phone</v-icon> Dispatch:
            96003317037548840091,7540091520,9597631302, 8870061845
          </p>
          <p class="mb-1">
            <v-icon color="primary" small>mdi-phone</v-icon> Complaint:
            9942449196,7540011846,7530027560,7530034370
          </p>
          <p class="mb-1">
            <v-icon color="primary" small>mdi-phone</v-icon> Address
            Confirmation: 9790431702,8148251846
          </p>
          <p class="mb-1">
            <v-icon color="primary" small>mdi-phone</v-icon> Transport L L R
            confirmation : 7708367545,9597681301
          </p>
          <p class="mb-1">
            <v-icon color="primary" small>mdi-phone</v-icon> Owner Number :
            9384755471
          </p>
          <p class="mb-1">
            <v-icon color="primary" small>mdi-email</v-icon>
            kannancrackers2015@gmail.com
          </p>
        </v-card-text> -->

        <v-card-text>
          <p class="mb-1 mt-5">
            <v-icon color="primary" small>mdi-phone</v-icon> Sivakasi : 81100
            20091
          </p>
          <p class="mb-1 text-no-wrap" style="font-size: 14px">
            <v-icon color="primary" small>mdi-phone</v-icon> Customer Support:
            97886 11845, 85250 00989, 95667 62040
          </p>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="contactDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Navigation Drawer-->
    <v-navigation-drawer v-model="drawer" absolute right temporary>
      <v-list nav dense>
        <v-list-item-group v-model="group" active-class="primary white--text">
          <div v-for="item in menus" :key="item.text">
            <v-list-item :href="item.href">
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
            <v-divider></v-divider>
          </div>
        </v-list-item-group>
      </v-list>
      <div v-for="item in getBlogList" :key="item.id">
        <v-list-item :href="`/blog/${item.id}`">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
      </div>
    </v-navigation-drawer>
    <!--Navigation Drawer-->

    <v-container>
      <div class="productdiv" ref="productdiv1"></div>
      <v-card class="mt-3 mx-auto" height="100" elevation="0">
        <div
          class="
            d-flex
            flex-column
            fill-height
            justify-center
            align-center
            text-black
          "
        >
          <h1 class="primary--text mt-3">&nbsp;</h1>
        </div>
      </v-card>

      <v-card
        class="mx-auto mb-5 ticket-card payment-ticket-card"
        outlined
        elevation="3"
      >
        <v-toolbar flat dark class="ticket-toolbar">
          <v-toolbar-title class="font-weight-medium">
            <v-icon left>mdi-cash-check</v-icon>
            Payment Confirmation
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pt-6 pb-2">
          <!--alert box-->
          <v-alert
            v-if="successResponse"
            type="success"
            text
            prominent
            border="left"
            class="mb-4 ticket-alert"
          >
            <!-- <v-icon left color="success">mdi-check-circle</v-icon> -->
            <div v-for="(error, i) in paymentResponse" :key="i">
              <h3 v-html="error"></h3>
            </div>
          </v-alert>

          <v-alert
            v-if="errorResponse"
            type="error"
            text
            prominent
            border="left"
            class="mb-4 ticket-alert"
          >
            <v-icon left color="error">mdi-alert</v-icon>
            <div v-for="(error, i) in paymentResponse" :key="i">
              <h3 v-html="error"></h3>
            </div>
          </v-alert>

          <!-- <v-form ref="fileForm" class="ma-5">
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-select
                v-model="ordertype"
                :items="ordertypes"
                item-text="name"
                item-value="id"
                label="Order Type *"
                required
                outlined
                @input="$v.ordertype.$touch()"
                @blur="$v.ordertype.$touch()"
                :error-messages="ordertypeErrors"
              ></v-select>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="orderno"
                :error-messages="ordernoErrors"
                label="Order No"
                required
                outlined
                @input="$v.orderno.$touch()"
                @blur="$v.orderno.$touch()"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="mobileno"
                :error-messages="mobilenoErrors"
                label="Mobileno"
                required
                outlined
                @input="$v.mobileno.$touch()"
                @blur="$v.mobileno.$touch()"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="12">
              <v-file-input
                label="Screen Shot"
                v-model="screenshot"
                required
                outlined
                :rules="imageRules"
                accept="image/png, image/jpeg, image/jpg"
                @change="screenshotSelected"
                :error-messages="screenshotErrors"
                @input="$v.screenshot.$touch()"
                @blur="$v.screenshot.$touch()"
              ></v-file-input>
            </v-col>

            <v-divider></v-divider>
            <v-col cols="12" sm="12" md="12">
              <v-btn
                class="float-right"
                outlined
                color="primary"
                @click="fileUpload"
                width="150"
                height="40"
              >
                <span class="black--text">UPLOAD</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form> -->

          <v-form
            ref="fileForm"
            class="ticket-form"
            @submit.prevent="fileUpload"
          >
            <v-sheet class="section-block" elevation="0">
              <div class="section-title">
                <v-icon left color="primary">mdi-receipt</v-icon>
                Order Details
              </div>

              <v-row>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="ordertype"
                    :items="ordertypes"
                    item-text="name"
                    item-value="id"
                    label="Order Type *"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-format-list-bulleted"
                    @input="$v.ordertype.$touch()"
                    @blur="$v.ordertype.$touch()"
                    :error-messages="ordertypeErrors"
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="customerName"
                    :error-messages="customerNameErrors"
                    label="Customer Name *"
                    outlined
                    dense
                    required
                    prepend-inner-icon="mdi-account"
                    @input="$v.customerName.$touch()"
                    @blur="$v.customerName.$touch()"
                    autocomplete="name"
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="orderno"
                    :error-messages="ordernoErrors"
                    label="Order No *"
                    required
                    outlined
                    dense
                    prepend-inner-icon="mdi-receipt"
                    @input="$v.orderno.$touch()"
                    @blur="$v.orderno.$touch()"
                    autocomplete="off"
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="mobileno"
                    :error-messages="mobilenoErrors"
                    label="Mobile No *"
                    required
                    outlined
                    dense
                    type="tel"
                    prepend-inner-icon="mdi-phone"
                    @input="$v.mobileno.$touch()"
                    @blur="$v.mobileno.$touch()"
                    autocomplete="tel"
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="email"
                    :error-messages="emailErrors"
                    label="Email (optional)"
                    outlined
                    dense
                    type="email"
                    prepend-inner-icon="mdi-email"
                    @input="$v.email.$touch()"
                    @blur="$v.email.$touch()"
                    autocomplete="email"
                  />
                </v-col>
              </v-row>
            </v-sheet>

            <v-divider class="my-6" />

            <v-sheet class="section-block" elevation="0">
              <div class="section-title">
                <v-icon left color="primary">mdi-credit-card</v-icon>
                Payment Details
              </div>

              <v-row>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="paymentMethod"
                    :items="paymentMethods"
                    item-text="name"
                    item-value="id"
                    label="Payment Method *"
                    outlined
                    dense
                    required
                    prepend-inner-icon="mdi-credit-card"
                    :error-messages="paymentMethodErrors"
                    @input="$v.paymentMethod.$touch()"
                    @blur="$v.paymentMethod.$touch()"
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="transactionId"
                    :error-messages="transactionIdErrors"
                    label="Transaction ID"
                    outlined
                    dense
                    required
                    prepend-inner-icon="mdi-identifier"
                    @input="$v.transactionId.$touch()"
                    @blur="$v.transactionId.$touch()"
                    autocomplete="off"
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="amountPaid"
                    :error-messages="amountPaidErrors"
                    label="Amount Paid *"
                    outlined
                    dense
                    required
                    type="number"
                    min="0"
                    step="0.01"
                    prepend-inner-icon="mdi-currency-inr"
                    @input="$v.amountPaid.$touch()"
                    @blur="$v.amountPaid.$touch()"
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-menu
                    ref="dateMenu"
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="paymentDate"
                        label="Payment Date *"
                        outlined
                        dense
                        required
                        readonly
                        prepend-inner-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        :error-messages="paymentDateErrors"
                      />
                    </template>
                    <v-date-picker
                      v-model="paymentDate"
                      @input="dateMenu = false"
                    />
                  </v-menu>
                </v-col>
              </v-row>
            </v-sheet>

            <v-divider class="my-6" />

            <v-sheet class="section-block" elevation="0">
              <div class="section-title">
                <v-icon left color="primary">mdi-image</v-icon>
                Upload Screenshot
              </div>

              <v-row>
                <v-col cols="12">
                  <v-file-input
                    v-model="screenshot"
                    label="Screen Shot *"
                    required
                    outlined
                    dense
                    prepend-icon="mdi-camera"
                    :rules="imageRules"
                    accept="image/png, image/jpeg, image/jpg"
                    @change="screenshotSelected"
                    :error-messages="screenshotErrors"
                    @input="$v.screenshot.$touch()"
                    @blur="$v.screenshot.$touch()"
                  />
                </v-col>
              </v-row>
            </v-sheet>

            <v-divider class="my-6" />

            <v-row>
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  color="primary"
                  large
                  class="px-8"
                  elevation="2"
                  @click="fileUpload"
                >
                  <v-icon left>mdi-upload</v-icon>
                  Upload
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>

    <!--footer Component-->
    <div>
      <footerCommon />
    </div>
  </div>
</template>

<style scoped>
.top-bar {
  position: fixed;
  width: 100%;
  z-index: 111;
}

.productdiv {
  margin-top: 100px !important;
}
.v-navigation-drawer {
  position: fixed !important;
}

/* Match the existing Ticket component look */
.ticket-card {
  max-width: 960px;
  border-radius: 16px;
  overflow: hidden;
}

.ticket-toolbar {
  background: linear-gradient(135deg, #2e7d32, #1b5e20);
}

.section-block {
  padding: 4px 4px 0;
}

.section-title {
  font-weight: 600;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  color: #424242;
}

.ticket-alert {
  border-radius: 8px;
}

@media (max-width: 600px) {
  .ticket-card {
    border-radius: 0;
  }
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";

// Custom validators
function validMobile(value) {
  return /^\d{10}$/.test(value);
}

function validEmail(value) {
  if (!value) return false;
  // Basic email regex
  return /^[^\s@]+@[^\s@]+\.(com|org|net|edu|gov|in|co|info|biz|me|io|us|uk|ca|au|de|fr|jp|cn|ru|br|za|eu|tv|xyz|site|online|store|tech|app|dev|ai|pro|club|shop|blog|news|live|digital|solutions|agency|group|company|center|systems|network|media|today|world|website|space|fun|press|cloud|design|studio|works|academy|consulting|events|finance|gallery|global|marketing|partners|support|ventures|zone|org|net|com)$/i.test(
    value
  );
}

function positiveAmount(value) {
  return Number(value) > 0;
}
import { VUE_WEB_BASEURL } from "../utils/api";
export default {
  name: "RetailPaymentConfirm",
  data: () => ({
    drawer: false,
    group: null,
    productRate: "0.00",
    productOfferPrice: "0.00",
    productSalesPrice: "0.00",
    contactDialog: false,
    cartQty: 0,
    menus: [
      {
        text: "Retail Price",
        disabled: false,
        href: "/",
      },
      {
        text: "Family pack",
        disabled: false,
        href: "familypack",
      },
      {
        text: "Wholesale case",
        disabled: false,
        href: "wholesale",
      },
      {
        text: "Whole sale",
        disabled: false,
        href: "diwali",
      },
      {
        text: "Gift box",
        disabled: false,
        href: "giftbox",
      },
      {
        text: "About Us",
        disabled: false,
        href: "aboutus",
      },
      {
        text: "Contact Us",
        disabled: false,
        href: "contactus",
      },
    ],
    ordertype: null,
    ordertypes: [
      { id: 1, name: "Retail Order" },
      { id: 2, name: "Family Pack" },
      { id: 3, name: "Wholesale Cash" },
      { id: 4, name: "Wholesale" },
      { id: 5, name: "Giftbox" },
    ],
    customerName: null,
    orderno: null,
    mobileno: null,
    email: null,
    paymentMethod: null,
    paymentMethods: [
      { id: 1, name: "Online Cash Deposit" },
      { id: 2, name: "GPay" },
      { id: 3, name: "Phonepay" },
      { id: 4, name: "Direct Bank Transfer" },
      { id: 5, name: "Others" },
    ],
    transactionId: null,
    amountPaid: null,
    screenshot: null,
    screenshotFile: null,
    paymentDate: null,
    dateMenu: false,
    imageRules: [
      (value) => !!value || "This Field is required",
      (value) =>
        !value ||
        value.size < 2000000 ||
        "Image size should be less than 2 MB!",
    ],
  }),
  validations: {
    ordertype: { required },
    orderno: { required },
    mobileno: { required, validMobile },
    customerName: { required },
    paymentMethod: { required },
    transactionId: {},
    amountPaid: { required, positiveAmount },
    paymentDate: { required },
    screenshot: { required },
    // email: { required, validEmail },
    email: { validEmail },
  },
  computed: {
    ...mapGetters([
      "authStatus",
      "getPaymentStatus",
      "paymentStatusResponse",
      "getBlogList",
    ]),
    ordertypeErrors() {
      const errors = [];
      if (!this.$v.ordertype.$dirty) return errors;
      !this.$v.ordertype.required && errors.push("Order Type is required");
      return errors;
    },
    ordernoErrors() {
      const errors = [];
      if (!this.$v.orderno.$dirty) return errors;
      !this.$v.orderno.required && errors.push("Orderno is required");
      return errors;
    },
    mobilenoErrors() {
      const errors = [];
      if (!this.$v.mobileno.$dirty) return errors;
      !this.$v.mobileno.required && errors.push("Mobileno is required");
      this.$v.mobileno.required &&
        !this.$v.mobileno.validMobile &&
        errors.push("Enter a valid 10-digit mobile number");
      return errors;
    },
    emailErrors() {
      const errors = [];
      // if (!this.$v.email.$dirty) return errors;
      // // !this.$v.email.required && errors.push("Email is required");
      // // this.$v.email.required && !this.$v.email.validEmail && errors.push("Enter a valid email address");
      // this.$v.email.required && !this.$v.email.validEmail && errors.push("Enter a valid email address");
      // return errors;
      // If the email field is dirty (has been touched) and there's a value
      if (this.$v.email.$dirty && this.$v.email.$model) {
        // Check if the entered value is not a valid email
        if (!this.$v.email.validEmail) {
          errors.push("Enter a valid email address");
        }
      }
      return errors;
    },
    customerNameErrors() {
      const errors = [];
      if (!this.$v.customerName.$dirty) return errors;
      !this.$v.customerName.required &&
        errors.push("Customer Name is required");
      return errors;
    },
    paymentMethodErrors() {
      const errors = [];
      if (!this.$v.paymentMethod.$dirty) return errors;
      !this.$v.paymentMethod.required &&
        errors.push("Payment Method is required");
      return errors;
    },
    // transactionIdErrors() {
    //   const errors = [];
    //   if (!this.$v.transactionId.$dirty) return errors;
    //   !this.$v.transactionId.required &&
    //     errors.push("Transaction ID is required");
    //   return errors;
    // },
    amountPaidErrors() {
      const errors = [];
      if (!this.$v.amountPaid.$dirty) return errors;
      !this.$v.amountPaid.required && errors.push("Amount Paid is required");
      this.$v.amountPaid.required &&
        !this.$v.amountPaid.positiveAmount &&
        errors.push("Amount must be greater than 0");
      return errors;
    },
    paymentDateErrors() {
      const errors = [];
      if (!this.$v.paymentDate.$dirty) return errors;
      !this.$v.paymentDate.required && errors.push("Payment Date is required");
      return errors;
    },
    screenshotErrors() {
      const errors = [];
      if (!this.$v.screenshot.$dirty) return errors;
      !this.$v.screenshot.required && errors.push("Screenshot is required");
      return errors;
    },
    errorResponse: function () {
      return this.getPaymentStatus === "error";
    },
    successResponse: function () {
      return this.getPaymentStatus === "success";
    },
    paymentResponse: function () {
      return this.paymentStatusResponse;
    },
  },
  created() {
    this.fetchBlog();
    this.$store.subscribe((mutation) => {
      //console.log(mutation);
      if (mutation.type === "paymentConfirmed") {
        this.ordertype = null;
        this.orderno = null;
        this.mobileno = null;
        this.screenshot = null;
        this.screenshotFile = null;
        this.customerName = null;
        this.email = null;
        this.paymentMethod = null;
        this.transactionId = null;
        this.amountPaid = null;
        this.paymentDate = null;
        this.$v.$reset();
      }
    });
  },
  methods: {
    ...mapActions(["retailPaymentConfirm", "fetchBlog"]),
    screenshotSelected(event) {
      console.log(event);
      let screenshot = event;
      // this.screenshotname = event.name;
      let reader = new FileReader();
      reader.readAsDataURL(screenshot);
      reader.onload = (event) => {
        this.screenshotFile = event.target.result;
      };
    },
    async fileUpload() {
      this.$v.$touch();
      // Email is not required, but if present, must be valid
      const isEmailValid =
        !this.email || (this.$v.email.$dirty && this.$v.email.validEmail);
      if (
        this.$v.ordertype.$invalid ||
        this.$v.customerName.$invalid ||
        this.$v.orderno.$invalid ||
        this.$v.mobileno.$invalid ||
        this.$v.paymentMethod.$invalid ||
        // this.$v.transactionId.$invalid ||
        this.$v.amountPaid.$invalid ||
        this.$v.paymentDate.$invalid ||
        this.$v.screenshot.$invalid ||
        !isEmailValid
      ) {
        console.log("ERROR");
      } else {
        setTimeout(() => {
          const orderData = {
            ordertype: this.ordertype,
            customerName: this.customerName,
            orderno: this.orderno,
            mobileno: this.mobileno,
            email: this.email,
            paymentMethod: this.paymentMethod,
            transactionId: this.transactionId,
            amountPaid: this.amountPaid,
            paymentDate: this.paymentDate,
            screenshot: this.screenshotFile,
          };
          // console.log(orderData);
          this.retailPaymentConfirm(orderData);
        }, 500);
      }
    },
    paymentYoutubeopen() {
      window.open("https://youtu.be/OGeCoK6bEeg", "_blank");
    },
    priceListOpen() {
      window.open(VUE_WEB_BASEURL + "retail-product/", "_blank");
    },
  },
};
</script>
